import { render, staticRenderFns } from "./References.vue?vue&type=template&id=6924a8f6&scoped=true&"
import script from "./References.vue?vue&type=script&lang=ts&"
export * from "./References.vue?vue&type=script&lang=ts&"
import style0 from "./References.vue?vue&type=style&index=0&id=6924a8f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6924a8f6",
  null
  
)

export default component.exports